import {Injectable, Injector} from '@angular/core';

import {Router} from '@angular/router';
import {NotifyService, PermissionCheckerService, SettingService,} from 'abp-ng2-module';

import {
    AddToFavoritesInputDto,
    ArticleDto,
    BasketArticleDto,
    BasketInputDto,
    CategoryDto,
    CreateOrderScheduleDto,
    CurrencyDto,
    FavoriteArticlesServiceProxy,
    IBasketArticleDto,
    IBasketInputDto,
    ICategoryDto,
    ICreateOrderScheduleDto,
    OrderGuideServiceProxy,
    OrderGuideSimpleDto,
    OrderScheduleServiceProxy,
    OrganizationUnitServiceProxy,
    PagedResultDtoOfArticleDto,
    PagedResultDtoOfFavoriteArticleDto,
    PagedResultDtoOfOrderGuideSimpleDto,
    PagedResultDtoOfVirtualDbRowDto,
    UserOrganizationUnitsDto,
    UserServiceProxy,
    VDBServiceProxy,
    VirtualDbRowDto,
    WebshopAuthenticatedUserInformationOutputDto,
    WebShopServiceProxy
} from '@shared/service-proxies/service-proxies';
import {catchError, finalize, map, take, tap} from 'rxjs/operators';
import moment from 'moment';
import * as _ from 'lodash-es';

import {BehaviorSubject, Observable, Subject, throwError} from 'rxjs';
import {AxillaPackage, AxillaPallet, BackOrder, BasketArticleExtendedDto} from '../models/models';
import {LazyLoadEvent} from 'primeng/api';
import {AppSessionService} from '@axilla/axilla-shared';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {FeatureDefinition} from '@shared/features/base-features-definitions';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';


@Injectable({
    providedIn: 'root',
})
export class WebshopService {

    //#region Global search
    globalSearchForm: UntypedFormGroup;

    private _isSearchAvailable = true;
    get isSearchAvailable(): boolean {

        const path = window.location.pathname;

        if (path.startsWith('/app/webshop/field-agent')
            || path.startsWith('/app/admin')) {
            this._isSearchAvailable = false;
        } else if (path.startsWith('/app/webshop')) {
            this._isSearchAvailable = true;
        } else {
            this._isSearchAvailable = false;
        }

        return this._isSearchAvailable;
    }

    //#endregion Global search

    sortOrder: number | undefined;
    sortField: string | undefined;

    protected orderStatesService: OrderStateService;
    protected permissionChecker: PermissionCheckerService;

    isLegacyUi = true;

    constructor(injector: Injector,
        private webShopServiceProxy: WebShopServiceProxy,
        private orderScheduleServiceProxy: OrderScheduleServiceProxy,

        private _favoriteServiceProxy: FavoriteArticlesServiceProxy,
        private _permissionCheckerService: PermissionCheckerService,

        private _orderGuideServiceProxy: OrderGuideServiceProxy,
        private _userServiceService: UserServiceProxy,
        private _ouServiceProxy: OrganizationUnitServiceProxy,
        private _router: Router,
        private _sessionService: AppSessionService,

        public _vdbService: VDBServiceProxy
    ) {
        this.notify = injector.get(NotifyService);
        this.setting = injector.get(SettingService);
        this.appSession = injector.get(AppSessionService);
        this.orderStatesService = injector.get(OrderStateService);
        this.permissionChecker = injector.get(PermissionCheckerService);

        this._initsearchForm();

        this._initUIspecification();

        this.IsShowAvailableStockInfoEnabled = this.setting.getBoolean('Pages.App.Webshop.View.ShowAvailableStockInfo')
            && this._sessionService.userId != null;

        this.getUserCurrency();

        this.getAllBanners();

        if (this.isPortal) {
            this.isBlocked();
        }

        this.initBasket();
        this.initPunchOut();


        if (this._permissionCheckerService.isGranted('Pages.App.Webshop.View.ShowAvailableStockInfo')) {
            this.initFavorites();
        }

        this._onBasketUpdate();
    }

    private _initsearchForm() {
        this.globalSearchForm = new UntypedFormGroup({
            filter: new UntypedFormControl(null),
        });
    }

    set isLoading(state: boolean) {
        this._isLoading = state;
    }
    get isLoading(): boolean {
        return this._isLoading;
    }
    set saving(value: boolean) {
        this._saving = value;
    }
    get saving(): boolean {
        return this._saving;
    }
    get favoritesCount(): number {
        return this._favoritesCount;
    }
    set favoritesCount(count: number) {
        this._favoritesCount = count;
    }
    set favoritesArticle(item: BasketArticleDto[]) {
        if (item) {
            this._favoritesArticle = [...item];
        }

        setTimeout(() => this.basketCounterUpdate.next(this.itemCount), 0);
    }
    get favoritesArticle(): BasketArticleDto[] {
        if (!this._favoritesArticle) {
            this._favoritesArticle = [];
        }

        return this._favoritesArticle;
    }
    set package(value: AxillaPackage) {
        this._package = value;
    }
    get package(): AxillaPackage {
        if (!this._package) {
            this.package = new AxillaPackage();
        }

        return this._package;
    }
    //set pallets(pallets: AxillaPallet[]) {
    //    if (item) {
    //        this._basket = [...item];
    //    }

    //    setTimeout(() => this.palletCounterUpdate.next(this.itemCount), 0);
    //}
    //get pallets(): AxillaPallet[] {
    //    if (!this._package) {
    //        this._package: UblionPackage = new AxillaPallet();
    //    }

    //    return this._basket;
    //}

    get palletCount(): number {
        return this._pallets.length;
    }
    set basket(item: any[]) {
        if (item) {
            this._basket = [...item];
        }

        setTimeout(() => this.basketCounterUpdate.next(this.itemCount), 0);
    }
    get basket(): any[] {
        if (!this._basket) {
            this._basket = [];
        }

        return this._basket;
    }

    get totalItemAmount(): number {
        let total = 0;
        if (!this._basket) {
            return total;
        }

        this._basket.forEach((item) => {
            total += item.quantity * item.price;

            if (item.backorderQuantity > 0) {
                total += item.backorderQuantity * item.price;
            }

        });

        return total;
    }

    get itemCount(): number {
        return this.basket.length;
    }
    set backOrder(value: BackOrder) {
        this._backOrder = value;
    }
    get backOrder(): BackOrder {
        if (!this._backOrder) {
            this.backOrder = new BackOrder();
        }

        return this._backOrder;
    }

    get isBackorderAvailable(): boolean {
        return this.backOrder.isBackorderAvailable;
    }

    get backorderBasket(): BasketArticleExtendedDto[] {
        return this.backOrder.backorderBasket;
    }
    set orderGuides(item: OrderGuideSimpleDto[]) {
        this._orderGuides = item;
    }
    get orderGuides(): OrderGuideSimpleDto[] {
        if (!this._orderGuides) {
            this._orderGuides = [];
        }

        return this._orderGuides;
    }


    get isOGBannerAvailable(): boolean {

        return this.isOGAvailable;
    }

    get isOGAvailable(): boolean {
        if (!this._orderGuides) { return false; }

        if (this._orderGuides.length > 0) {
            return true;
        }

        return false;
    }
    get ddOG(): any {
        return this._ddOG;
    }
    set ddOG(value: any) {
        this._ddOG = value;
    }
    set delivery(item: BasketArticleDto[]) {
        if (item) {
            this._delivery = [...item];
        }
    }
    get delivery(): BasketArticleDto[] {
        if (!this._delivery) {
            this._delivery = [];
        }

        return this._delivery;
    }
    set documents(item: BasketArticleDto[]) {
        if (item) {
            this._documents = [...item];
        }
    }
    get documents(): BasketArticleDto[] {
        if (!this._documents) {
            this._documents = [];
        }

        return this._documents;
    }
    set selectedDelivery(item: any) {
        this._selectedDelivery = item;
    }
    get selectedDelivery(): any {
        return this._selectedDelivery;
    }
    set additionalArticles(item: any[]) {
        if (item) {
            this._additionalArticles = [...item];
        }
    }
    get additionalArticles(): any[] {
        if (!this._additionalArticles) {
            this._additionalArticles = [];
        }

        return this._additionalArticles;
    }
    set agreements(agreement: any[]) {
        if (agreement) {
            this._agreements = [...agreement];
        }
    }
    get agreements(): any[] {
        if (!this._agreements) {
            this._agreements = [];
        }

        return this._agreements;
    }
    set minimumAmount(state: number) {
        this._minimumAmount = state;
    }
    get minimumAmount(): number {
        return this._minimumAmount;
    }


    //#endregion Minimum Amount

    // Portal Marriott
    //#region Portal Marriott
    get isPortal() {
        return location.hostname.includes('portal');
    }
    set registrationAvailability(state: boolean) {
        this._registrationAvailability = state;
    }
    get registrationAvailability(): boolean {
        return this._registrationAvailability;
    }
    set isRegistrationLoading(state: boolean) {
        this._isRegistrationLoading = state;
    }
    get isRegistrationLoading(): boolean {
        return this._isRegistrationLoading;
    }
    set isOuBlocked(value: boolean) {
        this._isOuBlocked = value;
    }
    get isOuBlocked(): boolean {
        return this._isOuBlocked;
    }
    set globalSearchFilter(value: string) {
        this._globalSearchFilter = value;
    }
    get globalSearchFilter(): string {
        return this._globalSearchFilter;
    }

    notify: NotifyService;
    setting: SettingService;
    appSession: AppSessionService;

    IsShowAvailableStockInfoEnabled: boolean;

    // General
    //#region General
    private _isLoading = false;

    private _isInitialized = false;

    private _saving: boolean;
    //#endregion General

    // Favorites
    //#region Favorites
    private readonly favoritesCounterUpdate = new BehaviorSubject<number>(0);
    favoritesCounterUpdate$ = this.favoritesCounterUpdate.asObservable();


    private _favoritesCount = 0;


    private _favoritesArticle: BasketArticleDto[];

    private _rowsAmount = 9;
    //#endregion Stock

    // Pallets
    //#region Pallets

    private readonly packageUpdate = new Subject<AxillaPackage>();
    packageUpdate$ = this.packageUpdate.asObservable();

    private readonly palletCounterUpdate = new BehaviorSubject<number>(0);
    palletCounterUpdate$ = this.palletCounterUpdate.asObservable();

    private _package: AxillaPackage;

    private _pallets: AxillaPallet[];

    basketUpdatetSubscription$;
    //#endregion Pallets

    // Basket
    //#region Basket

    private readonly basketUpdate = new Subject<BasketArticleDto[]>();
    basketUpdate$ = this.basketUpdate.asObservable();

    private readonly basketCounterUpdate = new BehaviorSubject<number>(0);
    basketCounterUpdate$ = this.basketCounterUpdate.asObservable();

    get basketCounterValue(): number {
        return this.basketCounterUpdate.value;
    }
    //private readonly basketClear = new Subject<any>();
    //basketClear$ = this.basketClear.asObservable();

    private _basket: any[];


    //#region Backorder

    private readonly backorderCounterUpdate = new BehaviorSubject<number>(0);
    backorderCounterUpdate$ = this.backorderCounterUpdate.asObservable();

    private _backOrder: BackOrder;

    //#endregion Backorder

    //#endregion Basket

    //PunchOut
    //#region PunchOut
    private readonly orderGuidesSubject = new Subject<OrderGuideSimpleDto[]>();
    orderGuides$ = this.orderGuidesSubject.asObservable();

    private _orderGuides: OrderGuideSimpleDto[];

    private _ddOG: any = [];

    bannerExists = false;
    bannerName = '';

    private _delivery: BasketArticleDto[];

    private _documents: BasketArticleDto[];


    //#region Delivery
    private _selectedDelivery: any;
    //#endregion

    //#endregion shiment OG

    // Additional Article
    //#region Additional Article

    private _additionalArticles: any[];


    //#endregion

    // Agreements
    //#region Agreements

    private _agreements: any[];


    //#endregion

    // Minimum Amount
    //#region Minimum Amount
    private _minimumAmount = 50;

    private _registrationAvailability = false;

    private _isRegistrationLoading = false;

    //#endregion Portal Marriott

    //BlockUser
    //#region BlockUser


    private _isOuBlocked = false;



    //#endregion BlockUser

    //USER OU
    // #region USER OU

    ous: UserOrganizationUnitsDto;
    selectedOu: any;

    private _globalSearchFilter = '';

    private _globalCurrency = 0;
    set globalCurrency(value: number) {
        this._globalCurrency = value;
    }
    get globalCurrency(): number {
        return this._globalCurrency;
    }
    private getUserCurrency() {
        this.webShopServiceProxy.getWebshopAuthenticatedUser()
            .subscribe((result: WebshopAuthenticatedUserInformationOutputDto) => {
                this.globalCurrency = result.currency || 0;
            });
    }

    resetAll() {
        this.basket = [];
        this._clearPallet();
        this.additionalArticles = [];
        this.selectedDelivery = undefined;
        this.agreements = [];


        this.navigatedashboard();
    }

    navigatedashboard(): void {
        this._router.navigate(['/app/webshop/dashboard']);
    }

    showLoader() {
        this.isLoading = true;
    }

    hideLoader() {
        this.isLoading = false;
    }

    getCurrency(currency?: number) {
        if (currency != null) {
            return CurrencyDto[currency];
        }

        return CurrencyDto[this.globalCurrency];
    }

    goHome() {
        this._router.navigate(['/app/ihsc/basket-overview']);
    }

    getSession() {
        if (abp.session.userId > 0) {
            return true;
        }
        return false;
    }

    login(): void {
        abp.event.trigger('app.show.loginModal');
    }

    addToFavorite($event: Event, product: ArticleDto) {
        $event.stopPropagation();
        if (this.getSession()) {
            let input = new AddToFavoritesInputDto();
            input.articleId = product.id;
            this._favoriteServiceProxy.addToFavorite(input)
                .subscribe(() => {
                    abp.notify.success('The article has been successfully added to favorites.');

                    this._setFavoriteCount(++this.favoritesCount);
                    this.getFavorites();
                });
        } else {
            this.login();
        }
    }

    removeFromFavorite($event: Event, productId: string) {
        $event.stopPropagation();
        if (this.getSession()) {
            this._favoriteServiceProxy.removeFromFavorite(productId)
                .subscribe(() => {
                    abp.notify.success('The article has been successfully removed from favorites.');

                    this._setFavoriteCount(--this.favoritesCount);
                    this.getFavorites();

                });
        } else {
            this.login();
        }
    }

    private _setFavoriteCount(count: number) {
        this.favoritesCount = count;

        this.favoritesCounterUpdate.next(this.favoritesCount);
    }

    initFavorites() {
        if (abp.session.userId > 0) {
            this.getFavorites();
        }
    }

    getFavorites$(filter?: string, event?: LazyLoadEvent): Observable<PagedResultDtoOfFavoriteArticleDto> {
        const skip = event?.first || 0;
        const take = event?.rows || this._rowsAmount;

        return this._favoriteServiceProxy.getAllFavoritesArticles(
            filter || undefined,
            undefined,
            skip,
            take)
            .pipe(
                tap((result: PagedResultDtoOfFavoriteArticleDto) => {
                    this.favoritesArticle = result.items.map(x => this._getBasketArticlesFromArticles(x.article));

                    this._setFavoriteCount(result.totalCount);
                })
            );
    }

    getFavorites(filter?: string, event?: LazyLoadEvent) {
        this.getFavorites$(filter, event)
            .pipe(
                take(1)
            ).subscribe((result: PagedResultDtoOfFavoriteArticleDto) => {
                this.favoritesArticle = result.items.map(x => this._getBasketArticlesFromArticles(x.article));

                this._setFavoriteCount(result.totalCount);
            });
    }

    private _getBasketArticlesFromArticles(articleDto: ArticleDto): BasketArticleDto {
        const input: IBasketArticleDto = articleDto as BasketArticleDto;
        const data = new BasketArticleDto(input);
        data.favorite = true;
        data.quantity = 1;
        return data;
    }

    //allows you to see the hearts in case you have a permission
    showFavorites() {
        return this.IsShowAvailableStockInfoEnabled;
    }
    //#endregion Favorites

    // Stock
    //#region Stock

    private _getStockAmount(): number {
        return _.random(0, 15);
    }

    initStockAmount(products: BasketArticleDto[]) {
        products.forEach((x: BasketArticleDto) => { x.stockAmount = this._getStockAmount(); });
    }

    private _onBasketUpdate() {
        this.basketUpdatetSubscription$ = this.basketUpdate$
            .subscribe((basket: BasketArticleDto[]) => {
                if (basket && basket.length === 0) {
                    this._clearPallet();
                } else {
                    this._updatePallet(basket);
                }
            });
    }

    private _updatePallet(basket: BasketArticleDto[]) {
        _.forEach(basket, (article: BasketArticleDto) => {
            this.package.addArticle(article);
        });

        setTimeout(() => this.packageUpdate.next(this.package), 0);
    }

    private _clearPallet(isSaved: boolean = false) {
        this.package.clear();

        setTimeout(() => this.packageUpdate.next(this.package), 0);
    }

    private _removePallet(id: string) {}

    private _convertToExtended(data: BasketArticleDto[]): BasketArticleExtendedDto[] {
        return data.map(x => {
            let extended = new BasketArticleExtendedDto(x);

            if (this.isBackorderFeatureEnabled) {
                if (extended.availableAmount < extended.quantity) {
                    extended.backorderQuantity = extended.quantity - extended.availableAmount;
                    extended.quantity = extended.availableAmount;
                }
            }

            return extended;
        });
    }

    initBasket() {
        if (this._isInitialized && this.itemCount === 0) {
            setTimeout(() => this.basketUpdate.next(this.basket), 0);
            return;
        }

        if (abp.session.userId > 0) {
            //Set minimum amount
            this.initMinimumOrderValue();

            this.webShopServiceProxy.getBasket()
                .subscribe((result: BasketInputDto) => {
                    let cookieArticles = abp.utils.getCookieValue('Basket');
                    abp.utils.deleteCookie('Basket');
                    if (!cookieArticles) {
                        cookieArticles = '[]';
                    }
                    let articlesToAdd = <BasketArticleExtendedDto[]>JSON.parse(cookieArticles);
                    let articles = articlesToAdd.map(x => {
                        x.lastModificationTime = moment(x.lastModificationTime);
                        x.creationTime = moment(x.creationTime);
                        let ogArticle = new BasketArticleExtendedDto(x);
                        return ogArticle;
                    });

                    if (result && result.items) {
                        this.basket = this._convertToExtended(result.items);
                    }

                    if (articles.length > 0) {
                        this.basket = this.basket.concat(articles);

                        this._updateBasket('');
                    }

                    this._isInitialized = true;

                    //check if backorder required
                    this.backOrder.check(_.cloneDeep(this.basket));

                    setTimeout(() => this.basketUpdate.next(this.basket), 0);
                    this.basketCounterUpdate.next(this.itemCount);
                });
        }
    }

    getCountById(id: string) {
        let item = _.find(this.basket,
            (item) => {
                return item.id === id;
            });

        return item?.quantity;
    }

    addItem(article: BasketArticleDto) {
        if (+article.quantity <= 0) {
            this.notify.info('Item quantity = 0, change Quantity');
            return;
        }

        //Concat additional params from extended data, create hash of it
        let item = _.find(this.basket,
            (item) => {
                if (this.isGuided
                    && (this.orderStatesService.isSelectPromotionState
                        || this.orderStatesService.isVerifyPromotionState)) {
                    return item.id === article.id && item.hash === article.hash;
                }
                return item.id === article.id;
            });

        if (this.isBackorderFeatureEnabled) {
            if (item) {
                if (+item.quantity === item.availableAmount) {
                    item.backorderQuantity += +article.quantity;
                } else {
                    const sum = +item.quantity + +article.quantity;
                    item.quantity = sum;

                    if (item.quantity > item.availableAmount) {
                        let deff = item.quantity - item.availableAmount;
                        item.backorderQuantity += deff;
                        item.quantity = item.availableAmount;
                    }
                }
            } else {
                let clone = _.cloneDeep(new BasketArticleExtendedDto(article));
                if (clone.quantity > clone.availableAmount) {
                    let deff = clone.quantity - clone.availableAmount;
                    clone.backorderQuantity += deff;
                    clone.quantity = clone.availableAmount;
                }

                this.basket = [...this.basket, clone];
            }

            //check if backorder required
            this.backOrder.check(_.cloneDeep(this.basket));
        } else {
            if (item) {
                item.quantity = +item.quantity + +article.quantity;
            } else {
                let clone = _.cloneDeep(new BasketArticleDto(article));
                this.basket = [...this.basket, clone];
            }
        }

        this.update();
    }

    changeItem(article: BasketArticleExtendedDto) {
        if (+article.quantity <= 0) {
            this.notify.info('Item quantity = 0, change Quantity');
            return;
        }

        let item = _.find(this.basket,
            (item) => {
                if (this.isGuided
                    && (this.orderStatesService.isSelectPromotionState
                        || this.orderStatesService.isVerifyPromotionState)) {
                    return item.id === article.id && item.hash === article.hash;
                }
                return item.id === article.id;
            });

        if (this.isBackorderFeatureEnabled) {
            this.updateQuantity(article);

            if (item) {
                item.quantity = article.quantity;
                item.backorderQuantity = article.backorderQuantity;

            } else {
                this.basket = [...this.basket, article];
                this.package.addArticle(article);
            }
        } else {
            if (item) {
                item.quantity = +article.quantity;
            } else {
                let clone = _.cloneDeep(new BasketArticleDto(article));
                this.basket = [...this.basket, clone];
            }
        }

        //check if backorder required
        this.backOrder.check(_.cloneDeep(this.basket));

        this.update('Item count successfully updated');
    }

    changeBackOrderItem(article: BasketArticleExtendedDto) {
        let item = _.find(this.basket,
            (item) => {
                return item.id === article.id;
            });

        if (item) {
            item.backorderQuantity = article.quantity;
        }

        //check if backorder required
        this.backOrder.check(_.cloneDeep(this.basket));

        this.update('Item count successfully updated');
    }

    private updateQuantity(article: BasketArticleExtendedDto) {
        let value = article.quantity;
        let basketItemRaw: any = article;
        // example: availableAmount 50
        // value: 51
        // dif -> -1
        let diff = article.availableAmount - value;

        if (diff < 0) {
            basketItemRaw.backorderQuantity += -diff;
            article.quantity = article.availableAmount;
        } else {
            let backorderDiff = basketItemRaw.backorderQuantity - diff;
            if (backorderDiff > 0) {
                basketItemRaw.backorderQuantity = backorderDiff;
                article.quantity = article.availableAmount;
            } else {
                if (value + article.backorderQuantity === article.availableAmount) {
                    article.quantity = article.availableAmount;
                } else {
                    article.quantity = value;
                }
                basketItemRaw.backorderQuantity = 0;
            }
        }

        basketItemRaw.realQuantity
            = basketItemRaw.backorderQuantity + article.quantity;
    }

    clear(isSaved: boolean = false) {
        if (abp.session.userId > 0) {
            this.webShopServiceProxy.clearBasket()
                .pipe(
                    finalize(() => { this.saving = false; })
                )
                .subscribe(() => {
                    abp.utils.deleteCookie('Basket');
                    this.basket = [];

                    //check if backorder required
                    this.backOrder.backorderBasket = [];
                    this.backOrder.check(_.cloneDeep(this.basket));

                    setTimeout(() => this.basketUpdate.next(this.basket), 0);
                    this.basketCounterUpdate.next(this.itemCount);
                    if (isSaved) {
                        document.getElementById('zycus-submit').click();
                        //this.spinnerService.hide();

                    }
                });
        } else {
            abp.utils.deleteCookie('Basket');
            this.basket = [];
            setTimeout(() => this.basketUpdate.next(this.basket), 0);
            this.basketCounterUpdate.next(this.itemCount);
        }
    }

    remove(article: BasketArticleDto) {
        if (!article?.id) { return; }

        let basket = this.basket;

        _.remove(basket,
            (item) => {
                if (this.isGuided
                    && (this.orderStatesService.isSelectPromotionState
                        || this.orderStatesService.isVerifyPromotionState)) {
                    return item.id === article.id && item.hash === article.hash;
                }
                return item.id === article.id;
            });

        this.basket = basket;

        //check if backorder required
        this.backOrder.check(this.basket);

        //TODO: implement Remove aticles
        this.package.removeArticle(article.id);

        this.update('Basket updated');
    }

    removeFromBackorder(id: string) {
        if (!id) { return; }

        let item = _.find(this.basket,
            (item) => {
                return item.id === id;
            });

        item.backorderQuantity = 0;

        this.backOrder.remove(id);

        //check if backorder required
        this.backOrder.check(_.cloneDeep(this.basket));

        this.update('Item count successfully updated');
    }

    confirm(roleForTarget?: string) {
        this.saving = true;

        //const data = this._getBasketForSave();
        let input = {
            delayTime: undefined,
            targetId: roleForTarget
        } as ICreateOrderScheduleDto;

        return this.orderScheduleServiceProxy.createOrder(new CreateOrderScheduleDto(input))
            .pipe(finalize(() => { this.saving = false; }));
    }

    update(message?: string) {
        if (abp.session.userId > 0) {
            this._updateBasket(message);
        } else {
            const data = this._getBasketForSave();
            abp.utils.setCookieValue('Basket', JSON.stringify(this.basket));
        }
    }

    private _updateBasket(message: string = 'Item added to basket') {
        const data = this._getBasketForSave();
        this.webShopServiceProxy.addItemsToBasket(data)
            .subscribe(() => {
                setTimeout(() => this.basketUpdate.next(this.basket), 0);
                if (message !== '') {
                    this.notify.success(message);
                }
            });
    }

    private _getBasketForSave(): BasketInputDto {
        let clone = _.cloneDeep(this.basket);

        let currentBasket = clone.map((x: BasketArticleDto | BasketArticleExtendedDto) => {
            x.categories = x.categories.map(category => new CategoryDto(category as ICategoryDto));
            if (x instanceof BasketArticleExtendedDto) {
                x.quantity += x.backorderQuantity;
            }
            return x as BasketArticleDto;
        });
        const input: IBasketInputDto = {
            items: currentBasket as BasketArticleDto[]
        };
        return new BasketInputDto(input);
    }
    private _initOGDd() {
        this.ddOG.unshift({
            label: 'Please select order guide',
            value: ''
        });

        _.each(this.orderGuides,
            (ou: OrderGuideSimpleDto) => {
                this.ddOG.push({
                    label: ou.code,
                    value: ou
                });
            });
    }

    private _selectRandomBanner(result: VirtualDbRowDto[]) {
        const element = _.sample(result);

        if (element) {
            this.bannerName = element.key;
        }
    }

    getAllBanners() {
        this.webShopServiceProxy.getAvailableBanners()
            .subscribe((result: PagedResultDtoOfVirtualDbRowDto) => {
                if (result && result.totalCount > 0) {
                    this.bannerExists = true;

                    this._selectRandomBanner(result.items);
                }
            });
    }

    initPunchOut() {
        //if (this._permissionCheckerService.isGranted('Pages.App.PunchOut.Order')) {
        this.isLoading = true;
        this.webShopServiceProxy.getOrderGuidesOverview(undefined, undefined, undefined, undefined, undefined, undefined, undefined)
            .pipe(
                take(1),
                map((result: PagedResultDtoOfOrderGuideSimpleDto) => {
                    this.orderGuides = result.items;
                    this._initOGDd();
                    this.isLoading = false;
                    this.orderGuidesSubject.next(result.items);
                }),
                catchError((err) => {
                    this.isLoading = true;
                    return throwError(err);
                })
            )
            .subscribe({
                next: () => {
                    //console.log('Order guides loaded successfully');
                },
                error: (err) => {
                    this.webShopServiceProxy.getOrderGuidesOverview(undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                        .pipe(
                            take(1),
                            map((result: PagedResultDtoOfOrderGuideSimpleDto) => {
                                this.orderGuides = result.items;
                                this._initOGDd();
                                this.isLoading = false;
                                this.orderGuidesSubject.next(result.items);
                            }),
                            catchError((err) => {
                                this.isLoading = false;
                                return throwError(err);
                            })
                        )
                        .subscribe();
                }
            });
        //}
    }
    //#endregion Basket

    // shiment OG
    //#region shiment OG

    getShipmentArticles(event?: LazyLoadEvent) {
        this.getShipmentArticles$(event).pipe(
            take(1)
        ).subscribe();
    }

    getShipmentArticles$(event?: LazyLoadEvent): Observable<PagedResultDtoOfArticleDto> {
        let shipmentOGId = '429d5f87-a97f-42ef-628f-08db41bb1642';

        return this._orderGuideServiceProxy.getOrderGuideArticles(
            undefined,
            undefined,
            shipmentOGId,
            undefined,
            0,
            100
        )
            .pipe(
                tap((result: PagedResultDtoOfArticleDto) => {
                    const articles = result.items;

                    let docs = _.filter(articles, (item: ArticleDto) => {
                        return item.code.includes('DOCUMENT');
                    });
                    this.documents = docs.map(x => this._getBasketArticles(x));

                    let del = _.filter(articles, (item: ArticleDto) => {
                        return item.code.includes('DELIVERY');
                    });
                    this.delivery = del.map(x => this._getBasketArticles(x));
                })
            );
    }

    private _getBasketArticles(articleDto: ArticleDto): BasketArticleDto {
        const input: IBasketArticleDto = articleDto as BasketArticleDto;
        const data = new BasketArticleDto(input);

        return data;
    }

    selectDelivery(delivery: any) {
        this.selectedDelivery = delivery;
    }

    addAdditionalArticle(article: any) {
        if (+article.quantity <= 0) {
            this.notify.info('Item quantity = 0, change Quantity');
            return;
        }

        let item = _.find(this.additionalArticles,
            (item) => {
                return item.code === article.code;
            });

        if (item) {
            const sum = +item.quantity + +article.quantity;
            item.quantity = sum;
        } else {
            this.additionalArticles = [...this.additionalArticles, article];
        }
    }

    removeAdditionalArticle(code: string) {
        if (!code) { return; }

        let basket = this.basket;

        _.remove(basket,
            (item) => {
                return item.code === code;
            });

        this.basket = basket;

    }

    acceptAgreement(agreement: any) {

        let item = _.find(this.agreements,
            (item) => {
                return item.id === agreement.id;
            });

        if (!item) {
            agreement.value = true;
            this.agreements = [...this.agreements, agreement];
        } else {
            this.removeAgreement(agreement.id);
        }

    }

    removeAgreement(id: string) {
        if (!id) { return; }

        let agreements = this.agreements;

        _.remove(agreements,
            (item) => {
                return item.id === id;
            });

        this.agreements = agreements;

    }

    validateAgreement(): boolean {
        if (this.agreements.length > 0) {

            let state = true;

            _.forEach(this.agreements, (agreement) => {
                if (!agreement.optional && !agreement.value) {
                    state = false;
                }
            });

            return state;
        }

        return false;
    }

    //check if current amount less than minimum amount
    checkMinimumAmountRequirements(): boolean {
        return this.itemCount > 0 && this.totalItemAmount < this.minimumAmount;
    }

    initMinimumOrderValue() {

        this.webShopServiceProxy
            .getMinimumOrderAmount()
            .subscribe((result: number) => {
                if (result) {
                    this.minimumAmount = result;
                }
            });
    }

    private _showRegistrationLoading() {
        this._isRegistrationLoading = true;
    }
    private _hideRegistrationLoading() {
        this._isRegistrationLoading = false;
    }

    initMarriottRegistration() {
        this._showRegistrationLoading();

        this.webShopServiceProxy
            .getRegistrationConfiguration()
            .pipe(
                finalize(() => this._hideRegistrationLoading())
            )
            .subscribe((result: VirtualDbRowDto) => {
                if (result && result.value) {
                    this.registrationAvailability = JSON.parse(result.value).Enabled;
                }
            });
    }

    isBlocked() {
        if (this._sessionService.user) {
            this.isBlocked$()
                .subscribe(result => {

                });
        }
    }

    isBlocked$(): Observable<boolean> {
        return this._ouServiceProxy.isCurrentOUIsBlocked()
            .pipe(
                tap(result => {
                    this.isOuBlocked = result;
                })
            );

    }

    _getUserOus$() {
        return this._userServiceService.getUserOrganizationUnits()
            .pipe(
                tap((data: UserOrganizationUnitsDto) => {
                    this.ous = data;
                    this.selectedOu = data.selectedOu;
                })
            )
            ;
    }
    // #endregion USER OU



    // Global Search
    // #region Global Search

    // Global filter
    // #region Global filter

    resetGlobalSearchFilter() {
        this.globalSearchFilter = '';
    }
    // #endregion Global filter

    // Table sorting
    // #region Table sorting
    resetSorting() {
        this.sortOrder = undefined;
        this.sortField = undefined;
    }
    onSortChange(value) {
        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    private _getSortOrder(filter?: any): string {
        let order = ' asc';
        if (filter?.sortOrder === 1 || filter?.event?.sortOrder === 1) {
            order = ' asc';
        } else {
            order = ' desc';
        }

        if (this.sortOrder === 1) {
            order = ' asc';
        } else {
            order = ' desc';
        }

        return order;
    }

    getOrder(event?: any) {
        const order = this._getSortOrder(event);

        let sorting = (event?.sortField ?? event?.event?.sortField ?? 'title') + order;
        if (this.sortField) {
            sorting = (this.sortField ?? 'title') + order;
        }

        return sorting;
    }
    // #endregion Table sorting

    // #endregion  Global Search

    updateArticleViewCounter(item: any) {
        if (!item) {
            return;
        }

        let article = (item.data ?? item) as ArticleDto;
        this.webShopServiceProxy.getArticle(article.id)
            .subscribe();
    }

    get isGuided(): boolean {
        const guidedUser = this.permissionChecker.isGranted(BasePermissionDefinition.Webshop.View.Guided);
        return guidedUser && !!abp.session.impersonatorUserId;
    }

    get isBackorderFeatureEnabled(): boolean {
        return abp.features.isEnabled(FeatureDefinition.App.Backorder);
    }

    goToBasket() {
        if (this.basketCounterValue === 0) {
            return;
        }

        if (this.isGuided) {
            if (this.orderStatesService.isSelectPromotionState) {
                this.orderStatesService.verifyPromotion();
            } else {
                this.orderStatesService.checkCart();
            }
        }

        this._router.navigate(['/app/webshop/basket-overview']);
    }

    private _initUIspecification() {
        if (abp.session.tenantId === 2) {
            this.isLegacyUi = false;
        }
    }
}
